<template>
  <EmailComponentsByRegulator />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
